<template>
  <a-row :span="24">
    <a-col :span="12">
      <div class="login-left-box">
        <img src="../../../assets/images/login_icon.png"/>
        <p class="title" v-if="brandReminder">{{ brandReminder }}</p>
        <p class="title" v-else>行业标杆品牌正在使用{{ platformName }}</p>
        <p class="tips">掘金社交电商、抢滩智慧新零售、落地小程序变现</p>
      </div>
    </a-col>
    <a-col :span="12">
      <div class="login-right-box">
        <div v-if="title" class="title-box">
          <img v-if="loginLogo" :src="loginLogo"/>
          <span class="platform-title">{{ title }}</span>
        </div>
        <template v-else>
          <img v-if="loginLogo" class="platform-icon" :src="loginLogo"/>
        </template>
        <slot></slot>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'UserComponent',

  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loginLogo: '',
      platformName: '',
      brandReminder: ''//品牌提示
    }
  },
  mounted() {
    let platformConfig = this.getPlatformConfig()
    this.loginLogo = platformConfig.loginLogo
    this.platformName = platformConfig.platformName
    this.brandReminder = platformConfig.brandReminder
  },
  methods: {}

}
</script>
<style scoped lang="less">
.login-left-box {
  text-align: center;
  float: right;
  margin-right: 20px;

  img {
    margin-top: 20px;
    width: 400px;
    height: 236px;
  }

  p {
    margin: 0;
    padding: 0;
  }

  .title {
    font-weight: 400;
    font-style: normal;
    color: #333333;
    margin-top: 10px;
  }

  .tips {
    font-weight: 400;
    font-style: normal;
    color: rgba(51, 51, 51, 0.7);
    margin-top: 10px;
  }
}

.login-right-box {
  float: left;
  width: 400px;
  margin-left: 20px;
  position: relative;
  text-align: left;

  .platform-icon {
    position: absolute;
    border-width: 0;
    left: 0;
    top: 14px;
    width: 80px;
    height: 32px;
  }

  .title-box {
    display: inline-block;
    margin-top: 14px;
    margin-bottom: 16px;
    height: 32px;

    img {
      border-width: 0;
      width: 80px;
      height: 32px;
      margin-right: 10px;
    }

    .platform-title {
      color: #333333;
      font-weight: 400;
      float: bottom;
    }
  }

}
</style>